module.exports = __webpack_public_path__ + "img/p-2.dd04758f.jpg";